import * as Scrivito from "scrivito";

Scrivito.provideComponent("Quote", ({ page }) => (
  <Scrivito.ContentTag tag="div" content={page} attribute="body" />
));
